/**
 * Services API - for consultant/consultation booking
 */

import { API_ENDPOINTS, BUSINESS_ID } from '../config/api';

export async function getServices(params = {}) {
  const query = { businessId: BUSINESS_ID, serviceType: 'bookable_individual', ...params };
  const res = await fetch(API_ENDPOINTS.services.public(query));
  if (!res.ok) throw new Error('Failed to load services');
  const data = await res.json();
  return data.services || [];
}

export async function getService(id) {
  const res = await fetch(API_ENDPOINTS.services.byId(id));
  if (!res.ok) throw new Error('Service not found');
  const data = await res.json();
  return data.service;
}

export async function getAvailableSlots(serviceId, date, businessId = BUSINESS_ID) {
  const params = { serviceId, date };
  if (businessId) params.businessId = businessId;
  const res = await fetch(API_ENDPOINTS.bookings.availableSlots(params));
  if (!res.ok) throw new Error('Failed to load available slots');
  const data = await res.json();
  return data.slots || [];
}

export async function createPublicBooking({ serviceId, startTime, customerName, customerEmail, customerPhone, deliveryMethod, notes, _hp }) {
  const res = await fetch(API_ENDPOINTS.bookings.public, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      serviceId,
      startTime,
      customerName,
      customerEmail,
      customerPhone: customerPhone || undefined,
      deliveryMethod,
      notes: notes || undefined,
      _hp: _hp || undefined,
    }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Booking failed');
  return data;
}
